import BaseMatcherController from "./base_matcher_controller"

// Children born within this inclusive range are eligible for a Trump Account.
// Built in local time so the comparison matches the date the user picks (parsed
// in local time below) and the server-side range in
// TrumpAccountQuestionnaire::ELIGIBLE_DOB_START/END.
const ELIGIBLE_DOB_START = new Date(2025, 0, 1)
const ELIGIBLE_DOB_END = new Date(2028, 11, 31)

export default class extends BaseMatcherController {
  static targets = [
    "previousLink",
    "stepContent",
    "ineligibleContent",
    "requiredText",
    "stepText",
    "childDobInput",
  ]

  // Child DOB — check eligibility range
  validateChildDob(event) {
    event.preventDefault()
    const stepContent = this.stepFor(event)
    if (!stepContent) return
    const requiredText = this.requiredTextFor(stepContent)

    // Collect date parts from simple_form date fields (year, month, day selects)
    // or a single date input
    let dobValue = null
    const dateInput = stepContent.querySelector("input[type='date']")
    const yearSelect = stepContent.querySelector("select[id$='_1i']")

    if (dateInput) {
      dobValue = dateInput.value
        ? new Date(`${dateInput.value}T00:00:00`)
        : null
    } else if (yearSelect) {
      const year = stepContent.querySelector("select[id$='_1i']")?.value
      const month = stepContent.querySelector("select[id$='_2i']")?.value
      const day = stepContent.querySelector("select[id$='_3i']")?.value
      if (year && month && day) {
        dobValue = new Date(
          `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}T00:00:00`,
        )
      }
    }

    if (!dobValue || isNaN(dobValue.getTime())) {
      this.toggleRequired(requiredText, true)
      return
    }

    this.toggleRequired(requiredText, false)

    const eligible =
      dobValue >= ELIGIBLE_DOB_START && dobValue <= ELIGIBLE_DOB_END

    if (!eligible) {
      this.showIneligible("dob")
    } else {
      this.nextStep()
    }
  }
}
